import { array, fn } from '@ember/helper';
import { Listbox } from 'tio-ui/components/collections';
import { on } from '@ember/modifier';
import { PhSortAscending, PhSortDescending } from 'ember-phosphor-icons';
import { Popover } from 'tio-ui/components/popover';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';

interface SortPopoverArgs {
  onSortSelect?: (option: string) => void;
  updateSortOrder: () => void;
  initial?: string;
  sortOrder?: boolean;
  sortOptions?: string[];
}

export default class SortPopoverComponent extends Component<SortPopoverArgs> {
  @tracked selected: string = this.args.initial ?? 'alphabetical';

  defaultOptions = ['alphabetical', 'date'];

  get options() {
    if (this.args.sortOptions) {
      return [...this.defaultOptions, ...this.args.sortOptions];
    }
    return this.defaultOptions;
  }

  handleMenuAction = (closePopover: () => void, key: string) => {
    this.selected = key;
    this.args.onSortSelect?.(key);
    closePopover();
  };

  updateSortOrder = () => {
    this.args.updateSortOrder();
  };

  <template>
    <div class="flex items-center gap-x-2">
      <button type="button" {{on "click" this.updateSortOrder}}>
        {{#if @sortOrder}}
          <PhSortAscending @size="20" />
        {{else}}
          <PhSortDescending @size="20" />
        {{/if}}
      </button>
      <Popover as |pop|>
        <button
          type="button"
          class="font-semibold text-ocean-600 hover:text-ocean-800 text-xs"
          {{pop.trigger}}
          {{pop.anchor}}
        >
          {{t "tas.dashboard.sort"}}
          {{this.selected}}
        </button>
        <pop.Content @size="sm" @class="overflow-hidden">
          <Listbox
            @isKeyboardEventsEnabled={{true}}
            @allowEmpty={{true}}
            @selectedKeys={{array this.selected}}
            @onAction={{fn this.handleMenuAction pop.close}}
            @intent="primary"
            @selectionMode="single"
            @class="w-full"
            as |l|
          >
            {{#each this.options as |option|}}
              <l.Item class="[&>span]:text-sm" @key={{option}}>
                {{option}}
              </l.Item>
            {{/each}}
          </Listbox>
        </pop.Content>
      </Popover>
    </div>
  </template>
}
